<template>
    <div class="triangle">
        <div class="triangleCon" :class="toggleClass()"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                params:{
                    isAnmite: null
                }
            }
        },
        methods: {
            start(props){
                this.params.isAnmite = props.isAnmite
            },
            toggleClass(){
                if(this.params.isAnmite === 1){
                    return 'anminteClass'
                }else if(this.params.isAnmite === 2){
                    return 'anmitionScoleLeave'
                }else{
                    return ''
                }
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .triangle{
        display: inline-block;
        .triangleCon{
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 6px solid #555555;
        }
        .anminteClass{
            animation: anmitionScole ease-in 0s;
            animation-fill-mode:forwards;
        }
        .anmitionScoleLeave{
            animation: anmitionScoleLeave ease-in 0s;
            animation-fill-mode:forwards;
        }
        @keyframes anmitionScole {
            from {
                transform:rotate(0deg);
                -ms-transform:rotate(0deg); 	/* IE 9 */
                -moz-transform:rotate(0deg); 	/* Firefox */
                -webkit-transform:rotate(0deg); /* Safari 和 Chrome */
                -o-transform:rotate(0deg)
            }
            to {
                transform:rotate(180deg);
                -ms-transform:rotate(180deg); 	/* IE 9 */
                -moz-transform:rotate(180deg); 	/* Firefox */
                -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
                -o-transform:rotate(180deg)
            }
        }
        @keyframes anmitionScoleLeave {
            from {
                transform:rotate(180deg);
                -ms-transform:rotate(180deg); 	/* IE 9 */
                -moz-transform:rotate(180deg); 	/* Firefox */
                -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
                -o-transform:rotate(180deg)
            }
            to {
                transform:rotate(360deg);
                -ms-transform:rotate(360deg); 	/* IE 9 */
                -moz-transform:rotate(360deg); 	/* Firefox */
                -webkit-transform:rotate(360deg); /* Safari 和 Chrome */
                -o-transform:rotate(360deg)
            }
        }
    }
</style>